export const typography = {
  fontFamilyPrimary: "'Poppins', sans-serif",
  fontFamilySecondary: "'Roboto', sans-serif",
  fontFamilyGeogrotesque: "'Geogrotesque Sharp', sans-serif",
  fontWeights: {
    regular: 400,
    bold: 700,
  },
  fontSizes: {
    small: '12px',
    medium: '16px',
    large: '20px',
    xlarge: '24px',
  },
};
